import { atom } from "jotai";

export const FilterResetAtom = atom(0);
